import { Validators } from '@angular/forms';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';
import { crossFieldValidator } from '@shared/validators/cross-field-validator';
import { errorValueValidator } from '@shared/validators/error-value-validator';

export const galleriValidationSet: ValidationPair = {
  children: {
    galleri: {
      children: {
        currentPregnancyInformation: {
          children: {
            isPregnant: {
              validators: [Validators.required, errorValueValidator(true)],
            },
          },
        },
        patientHistory: {
          children: {
            currentlyDiagnosedWithCancer: {
              validators: [Validators.required, errorValueValidator(true)],
            },
            cancerSurvivor: {
              children: {
                isSurvivor: {
                  validators: [Validators.required],
                },
                moreThanThreeYearsAgo: {
                  validators: [errorValueValidator(false)],
                },
              },
            },
            solidOrganTransplant: {
              children: {
                hasReceived: {
                  validators: [Validators.required],
                },
              },
            },
            cancerSuspicion: {
              children: {
                isSuspicious: {
                  validators: [Validators.required],
                },
              },
              validators: [
                crossFieldValidator(
                  'suspicionDescription',
                  'isSuspicious',
                  true
                ),
              ],
            },
          },
        },
      },
      validators: [
        crossFieldValidator(
          'patientHistory.cancerSurvivor.moreThanThreeYearsAgo',
          'patientHistory.cancerSurvivor.isSurvivor',
          true
        ),
      ],
    },
    shared: {
      children: {
        patientGender: {
          validators: [Validators.required],
        },
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
        patientHistory: {
          children: {
            boneMarrowTransplant: {
              children: {
                hasReceived: {
                  validators: [Validators.required],
                },
              },
            },
          },
        },
      },
    },
  },
};
